import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { App } from '@vendasta/embeddings';
import { AiKnowledgeService } from '../ai-knowledge.service';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { AiKnowledgeI18nModule } from '../assets/i18n/ai-knowledge-i18n.module';

@Component({
  selector: 'ai-knowledge-apps-for-knowledge-source',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AiKnowledgeI18nModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    MatListModule,
    GalaxyLoadingSpinnerModule,
    GalaxyEmptyStateModule,
  ],
  templateUrl: './apps-for-knowledge-source.component.html',
})
export class AppsForKnowledgeSourceComponent implements OnInit {
  @Input() knowledgeSourceId: string;

  readonly apps = signal<App[]>([]);
  private readonly customKnowledgeService = inject(AiKnowledgeService);
  readonly isLoading = signal(true);

  async ngOnInit(): Promise<void> {
    this.apps.set(await this.customKnowledgeService.listAllAppsForKnowledgeSource(this.knowledgeSourceId));
    this.isLoading.set(false);
  }
}
